import Vue from 'vue';
import { LoadingService } from '@/services/index';
import { EventBus } from '@/event-bus/index';
import { getContentArea } from '@/contentful/index';

export default Vue.extend({
  methods: {
    openForgotPasswordScreen(params): void {
      LoadingService.watchPromises(getContentArea([
        'forgot-password-success',
        'forgot-password-error-default',
        'forgot-password-error-no-email-address-on-file',
        'forgot-password-error-username-not-found',
        'token-expired-error',
        'update-password-error-history',
        'update-password-error-name',
        'update-password-error-age',
      ])).then((data) => {
        const CONTENT_AREAS = data[0];
        let paramsObj: any = {};
        if (CONTENT_AREAS) {
          if (CONTENT_AREAS[0] && CONTENT_AREAS[0].fields) {
            paramsObj.successMessage = CONTENT_AREAS[0].fields.content;
          }
          if (CONTENT_AREAS[1] && CONTENT_AREAS[1].fields) {
            paramsObj.errorMessage = CONTENT_AREAS[1].fields.content;
          }
          if (CONTENT_AREAS[2] && CONTENT_AREAS[2].fields) {
            paramsObj.errorMessageNoEmail = CONTENT_AREAS[2].fields.content;
          }
          if (CONTENT_AREAS[3] && CONTENT_AREAS[3].fields) {
            paramsObj.errorMessageNoUsername = CONTENT_AREAS[3].fields.content;
          }
          if (CONTENT_AREAS[4] && CONTENT_AREAS[4].fields) {
            paramsObj.errorMessageTokenInvalid = CONTENT_AREAS[4].fields.content;
          }
          if (CONTENT_AREAS[5] && CONTENT_AREAS[5].fields) {
            paramsObj.errorMessagePasswordReused = CONTENT_AREAS[5].fields.content;
          }
          if (CONTENT_AREAS[6] && CONTENT_AREAS[6].fields) {
            paramsObj.errorMessagePasswordName = CONTENT_AREAS[6].fields.content;
          }
          if (CONTENT_AREAS[7] && CONTENT_AREAS[7].fields) {
            paramsObj.errorMessagePasswordAge = CONTENT_AREAS[7].fields.content;
          }
        }
        paramsObj = Object.assign(paramsObj, params);
        EventBus.$emit('openOverlayWrapper', 'forgotPassword', paramsObj);
      }).catch(() => {
        EventBus.$emit('openModal', 'Error', {
          message: 'global_connection-error',
        });
      });
    },
  },
});
